import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';

interface ColorPickerProps {
    label: string;
    value: string;
    onChange: (value: string) => void;
    defaultValue?: string;
    required?: boolean;
    controlId: string;
}

const ColorPicker: React.FC<ColorPickerProps> = ({
    label,
    value,
    onChange,
    defaultValue,
    required = false,
    controlId
}) => {
    const handleColorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newColor = e.target.value;
        const isValidHex = /^#([0-9A-F]{3}|[0-9A-F]{6})$/i.test(newColor);
        const emptyColor = newColor === '';
        if (isValidHex || emptyColor) {
            onChange(newColor);
        }
    };

    const displayValue = value || defaultValue || '';

    return (
        <Form.Group controlId={controlId}>
            <Form.Label>{label}</Form.Label>
            <InputGroup>
                <input
                    type="color"
                    required={required}
                    value={displayValue}
                    onChange={handleColorChange}
                    className="form-control form-control-color"
                />
                <input
                    className="form-control"
                    type="text"
                    onChange={handleColorChange}
                    value={displayValue}
                />
            </InputGroup>
        </Form.Group>
    );
};

export default ColorPicker;